import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-wellcome",
  templateUrl: "./wellcome.component.html",
  styleUrls: ["./wellcome.component.css"]
})
export class WellcomeComponent implements OnInit {
  @Input() keterangan: any;

  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/components/wellcome/wellcome.component.ts